import { render, staticRenderFns } from "./Society.vue?vue&type=template&id=0666f114&scoped=true&"
import script from "./Society.vue?vue&type=script&lang=js&"
export * from "./Society.vue?vue&type=script&lang=js&"
import style0 from "./Society.vue?vue&type=style&index=0&id=0666f114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0666f114",
  null
  
)

export default component.exports